/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useMemo } from 'react';

import { useFormik } from 'formik';

import {
  getProInfo,
  proInfo,
  updateProInfo,
  getTypeOfUser,
  userActions,
} from '@pharmaplan/common';

import { useAppDispatch } from '../../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import useSelfService from '../../../../hooks/useSelfService';
import useDisableProfileSave from '../../../../hooks/useDisableProfileSave';
import {
  professionalCorporatedValidator,
  ProInfoValidator,
} from '../../FormValidation';
import ProfileForm from '../../ProfileForm';
import { ICommonProfile } from '../General/General';

const ProfessionalInfo = ({ setSelected }: ICommonProfile) => {
  const dispatch = useAppDispatch();
  const info = useAppSelector(proInfo);
  const userType = useAppSelector(getTypeOfUser);
  const { isSelfService } = useSelfService();

  const getMinusCurrentYear = (year: number) =>
    new Date().getFullYear() - year;

  const initialValue = useMemo(
    () =>
      ({
        ...info,
        incorporated: `${info?.incorporated}`,
        role: userType,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [info],
  );

  const formik = useFormik({
    initialValues: initialValue,

    onSubmit: (values) => {
      dispatch(
        updateProInfo({
          ...values,
          incorporated: values?.incorporated === 'true',

        }),
      );
    },
    enableReinitialize: true,
    validationSchema: isSelfService
      ? professionalCorporatedValidator()
      : ProInfoValidator(),
  });

  useEffect(() => {
    formik.setFieldValue(
      'yearsOfExperience',
      getMinusCurrentYear(parseInt(formik.values.graduationYear, 10)),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.graduationYear]);

  useEffect(() => {
    dispatch(getProInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formik.setValues({
      ...info,
      role: userType,
      englishLevel: info.englishLevel.toString(),
      incorporated: `${info?.incorporated}`,
      frenchLevel: info.frenchLevel.toString(),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info]);

  const { disabled } = useDisableProfileSave({
    action: userActions.professionalInformation_update,
    mutableValues: formik.values,
    initialValue,
  });

  return (
    <ProfileForm
      setSelected={setSelected}
      selected="professionalInfo"
      formik={formik}
      disableSave={disabled}
    />
  );
};

export default ProfessionalInfo;
